import React from 'react';
import '../../styles/TermsModal.scss';

interface TermsModalProps {
  title: string;
  content: string;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ title, content, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} className="terms-content" />
        <div className="modal-footer">
          <button className="agree-button" onClick={onClose}>
            동의하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
